import React from 'react';
import { MoonIcon } from 'lucide-react';
import { useRoleTheme } from '../../hooks/useRoleTheme';
const darknessLevels: Record<number, {
  label: string;
  color: string;
  darkColor: string;
}> = {
  1: {
    label: 'Hint of Shadow',
    color: 'bg-slate-100 text-slate-600',
    darkColor: 'bg-slate-700/40 text-slate-300'
  },
  2: {
    label: 'Into the Grey',
    color: 'bg-slate-200 text-slate-700',
    darkColor: 'bg-slate-600/50 text-slate-200'
  },
  3: {
    label: 'Embrace the Abyss',
    color: 'bg-slate-600 text-slate-100',
    darkColor: 'bg-slate-500/60 text-slate-100'
  },
  4: {
    label: 'Pitch Black',
    color: 'bg-gray-800 text-gray-100',
    darkColor: 'bg-gray-700 text-gray-100'
  },
  5: {
    label: 'The Void',
    color: 'bg-gray-950 text-white',
    darkColor: 'bg-black/70 text-white'
  }
};
interface DarkLevelIndicatorProps {
  level: number;
  darkMode?: boolean;
}
const DarkLevelIndicator: React.FC<DarkLevelIndicatorProps> = ({
  level = 0,
  darkMode = false
}) => {
  const rt = useRoleTheme();
  if (level <= 0 || !darknessLevels[level]) return null;
  const {
    label,
    color,
    darkColor
  } = darknessLevels[level];
  return <span className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 ${rt.badgeRadius} font-medium ${darkMode ? darkColor : color}`} data-id="element-3722" data-mp="fmni3na01jcv">
      <MoonIcon className="h-3 w-3" data-id="element-3723" data-mp="kk6xwrmci46x" />
      {label}
    </span>;
};
export default DarkLevelIndicator;